<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-img :src="require('@/assets/img-banner-inner.jpg')" />
    <v-container class="py-4 mb-8">
      <div
        class="text-h1 font-medium line-bottom"
        :class="$store.state.mobile ? 'mb-10' : 'my-6'"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          اترك رسالة
        </template>
        <template v-else>
          Feedback
        </template>
      </div>
      <div class="mb-8">
        <template v-if="$store.getters.languageGetter === '1'">
          إذا كان لديك أي اقتراحات أو أسئلة لنا ، يرجى الاتصال بنا.
        </template>
        <template v-else>
          If you have any suggestions or question for us.Please contact us.
        </template>
      </div>
      <v-scroll-y-transition>
        <v-alert
          v-if="success"
          type="success"
          class="mb-4"
        >
          <template v-if="$store.getters.languageGetter === '1'">
            نجاح
          </template>
          <template v-else>
            Success
          </template>
        </v-alert>
      </v-scroll-y-transition>
      <v-row align="center">
        <v-col
          sm="6"
          class="py-0"
        >
          <v-text-field
            v-model="feedback.company"
            :rules="companyRules"
            :label="$store.getters.languageGetter === '1' ? 'اسم الشركة' : 'Company'"
            required
            outlined
            dense
            clearable
            class="rounded-0"
          />
        </v-col>
        <v-col
          sm="6"
          class="py-0"
        >
          <v-text-field
            v-model="feedback.phone"
            :label="$store.getters.languageGetter === '1' ? 'هاتف' : 'Phone'"
            required
            outlined
            dense
            clearable
            class="rounded-0"
          />
        </v-col>
        <v-col
          cols="12"
          class="py-0"
        >
          <v-text-field
            v-model="feedback.email"
            :rules="emailRules"
            :label="$store.getters.languageGetter === '1' ? 'البريد الإلكتروني' : 'Email'"
            required
            outlined
            dense
            clearable
            class="rounded-0"
          />
        </v-col>
        <v-col
          cols="12"
          class="py-0"
        >
          <v-text-field
            v-model="feedback.subject"
            :rules="subjectRules"
            :label="$store.getters.languageGetter === '1' ? 'موضوعات' : 'Subject'"
            required
            outlined
            dense
            clearable
            class="rounded-0"
          />
        </v-col>
        <v-col
          cols="12"
          class="py-0"
        >
          <v-textarea
            v-model="feedback.content"
            :rules="contentRules"
            :label="$store.getters.languageGetter === '1' ? 'محتوى الرسالة' : 'Message content'"
            required
            outlined
            dense
            clearable
            rows="15"
            class="rounded-0"
          />
        </v-col>
        <v-col
          cols="12"
          class="py-0"
        >
          <v-btn
            :disabled="!valid"
            :loading="submitting"
            :block="$store.state.mobile"
            color="primary"
            class="text-uppercase px-12 rounded-0"
            large
            @click="submitForm"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يقدم
            </template>
            <template v-else>
              Submit
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Feedback',
  data() {
    return {
      valid: true,
      submitting: false,
      success: false,
      feedback: {
        company: '',
        phone: '',
        email: '',
        subject: '',
        content: '',
      },
      emailRules: [(v) => !!v || 'Please enter your email', (v) => /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(v)
          || 'This is not a correct email address'],
      companyRules: [(v) => !!v || 'Please fill in your company name'],
      subjectRules: [(v) => !!v || 'Please fill in the subject'],
      contentRules: [(v) => !!v || 'Please fill in message content'],
    };
  },
  methods: {
    ...mapActions(['addFeedbackAsync']),
    submitForm() {
      if (this.$refs.form.validate()) {
        this.submitting = true;
        this.addFeedbackAsync(this.feedback).then(() => {
          this.success = true;
        }).finally(() => {
          this.submitting = false;
        });
      }
    },
  },
};
</script>
